import React, {Component} from "react";

export default class SuccessUploadStep extends Component {
    constructor() {
        super(...arguments);
    }

    render() {
        return (
            <div>
                <div className="define-application">
                    <div className="success-info">
                        <b>{window.translates.add_docs.success_upload}</b>
                    </div>
                </div>
            </div>
        );
    }
}
